__turbopack_context__.v({
  "actions": "PortalPasses-module__K66jpW__actions",
  "archive": "PortalPasses-module__K66jpW__archive",
  "badge": "PortalPasses-module__K66jpW__badge",
  "balance": "PortalPasses-module__K66jpW__balance",
  "confirmation": "PortalPasses-module__K66jpW__confirmation",
  "detail": "PortalPasses-module__K66jpW__detail",
  "digitalCard": "PortalPasses-module__K66jpW__digitalCard",
  "empty": "PortalPasses-module__K66jpW__empty",
  "expanded": "PortalPasses-module__K66jpW__expanded",
  "grid": "PortalPasses-module__K66jpW__grid",
  "heading": "PortalPasses-module__K66jpW__heading",
  "history": "PortalPasses-module__K66jpW__history",
  "muted": "PortalPasses-module__K66jpW__muted",
  "notice": "PortalPasses-module__K66jpW__notice",
  "offer": "PortalPasses-module__K66jpW__offer",
  "offerFooter": "PortalPasses-module__K66jpW__offerFooter",
  "order": "PortalPasses-module__K66jpW__order",
  "orders": "PortalPasses-module__K66jpW__orders",
  "page": "PortalPasses-module__K66jpW__page",
  "pass": "PortalPasses-module__K66jpW__pass",
  "passTop": "PortalPasses-module__K66jpW__passTop",
  "price": "PortalPasses-module__K66jpW__price",
  "section": "PortalPasses-module__K66jpW__section",
  "textButton": "PortalPasses-module__K66jpW__textButton",
  "validity": "PortalPasses-module__K66jpW__validity",
});
